'use strict';

function CompanyInvestigationPagesService($resource, config) {
  return $resource(config.apiBase + '/companies/gdpr-pages/:gdprPageId', {}, {});
}

angular.module('dokiv')
  .factory('CompanyInvestigationPagesService', ['$resource', 'config', CompanyInvestigationPagesService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/investigation/CompanyInvestigationPagesService.js
// module id = 399
// module chunks = 0